import React from "react";
import "./Footer.scss";
import * as CONTACT_DETAILS from "content/site/contactDetails.json";

type State = {
  hover: boolean;
};

class Footer extends React.Component<{}, State> {
  state = {
    hover: false,
  };

  render() {
    const contactDetails = CONTACT_DETAILS;
    // const config = SITE_SETTINGS;
    return (
      <section className="Footer_root">
        <a className="w-40" href="/beeas-2014-winner.pdf">
          <img
            className="Footer_blogo"
            src={
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxkeVpkfkioXByoCGnQugh7TrAh4UbfjH91w&s"
            }
            alt="beeas 2014 winner"
          />
        </a>
        <div className="Footer_content">
          {/* <div className="Footer_socials">
            <SocialMedia />
          </div> */}
          <div className="Footer_address font-normal">
            <h6>{contactDetails.address}</h6>
            <h6>
              {contactDetails.phoneNumber} | {contactDetails.email}
            </h6>
            <a className="text-bulletpoint-blue" href="/privacyPolicy">
              Privacy Policy
            </a>
          </div>
        </div>
      </section>
    );
  }

  private onFooterClick = () => {
    window.open("https://www.dota2.com/home");
  };
  private onHover = () => {
    this.setState({ hover: true });
  };
  private onLeaveHover = () => {
    this.setState({ hover: false });
  };
}

export default Footer;
